module.exports = __webpack_public_path__ + "img/colorful1-end.31b7e837.png";